<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-flex xs6 sm3 md3>
        <v-btn color="primary" dark class="mb-2" @click="addItem()" round>Add ISP to Network</v-btn>
      </v-flex>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :items="customers"
      :rows-per-page-items="[10, 25, 50, 100]"
      :loading="isloading"
      align-center
      color="white"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon @click="editItem(props.item)">edit</v-icon>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                medium
                @click="removeIspFromNetwork(props.item)"
                color="red"
              >remove_circle</v-icon>
            </template>
            <span>Remove ISP from Network</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="text-xs-center">
          {{ sharedPackages(props.item) }}
          <!-- {{props.item.packagesFno.length}}/{{fnopackages.length}} -->
        </td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
    <v-dialog persistent v-model="addIspModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD ISP TO NETWORK</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs8 sm8 md8>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="isps"
                  v-model="selectedIsp"
                  item-text="name"
                  item-value="id"
                  label="Select ISP to Add"
                ></v-autocomplete>
              </v-flex>
              <v-flex>
                <v-data-table
                  v-if="selectedIsp"
                  :headers="fnoHeaders"
                  v-model="selected"
                  class="elevation-1"
                  :search="search"
                  :items="fnopackages"
                  :rows-per-page-items="[10, 25, 50, 100]"
                  :loading="isloading"
                  align-center
                  disable-initial-sort
                  color="white"
                  select-all
                >
                  <template v-slot:items="props">
                    <td>
                      <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
                    </td>
                    <td class="text-xs-center">{{props.item.packagesFnoCat.name}}</td>
                    <td class="text-xs-center">{{props.item.packageCode}}</td>
                    <td class="text-xs-center">
                      {{props.item.speedProfile.downloadMbps}}/
                      {{props.item.speedProfile.uploadMbps}} Mbps {{props.item.speedProfile.contentionRatio}}
                    </td>
                    <td class="text-xs-center">{{props.item.packageBasePrice | currency}}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="addIspModal=false">Cancel</v-btn>
            <v-btn color="primary" round @click="addIspToNetwork()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editIspModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">{{item.name}}</h1>
        </v-toolbar>
        <v-data-table
          :headers="fnoHeaders"
          v-model="selected"
          class="elevation-1"
          :search="search"
          :items="fnopackages"
          :rows-per-page-items="[10, 25, 50, 100]"
          :loading="isloading"
          align-center
          disable-initial-sort
          color="white"
          select-all
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
            </td>
            <td class="text-xs-center">{{props.item.packagesFnoCat.name}}</td>
            <td class="text-xs-center">{{props.item.packageCode}}</td>
            <td class="text-xs-center">
              {{props.item.speedProfile.downloadMbps}}/
              {{props.item.speedProfile.uploadMbps}} Mbps {{props.item.speedProfile.contentionRatio}}
            </td>
            <td class="text-xs-center">{{props.item.packageBasePrice | currency}}</td>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="editIspModal=false, item={}">Cancel</v-btn>
            <v-btn color="primary" round @click="saveEditedIsp()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import VueCurrencyFilter from "vue-currency-filter";
import Api from "@/services/Api";
export default {
  props: [
    "packagesisplocationnetworks",
    "speedprofiles",
    "packagetypes",
    "customers",
    "isps",
    "fnopackages",
    "networkhasfnopackages",
    "isloading"
  ],
  components: {
    "vue-currency-filter": VueCurrencyFilter
  },
  watch: {
    filterPackages(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          locationNetworkId: this.$route.params.locationNetworkId,
          customerId: this.filterIsp,
          speedProfileId: this.filterSpeed,
          packageType: this.filterPackageType
        };
        this.$router.push(route);
        this.filterPackages = false;
      }
    }
  },

  data() {
    return {
      loading: false,
      snackbar: false,
      editIspModal: false,
      item: {},
      initialSelectedPackages: [],
      pagination: {
        descending: true,
        sortBy: "customerOrganisation.name"
      },
      text: "",
      y: "top",
      selected: [],
      filterPackages: false,
      removeISP: [],
      selectedIsp: "",
      removeIspModal: false,
      chosenIsps: [],
      packageBatchNumber: null,
      addIspModal: false,
      filterIsp: null,
      filterSpeed: null,
      filterPackageType: null,
      search: "",
      pagination: {},
      fnoPackages: [
        {
          endDate: "",
          isActive: "",
          isDeleted: "",
          isPromotion: "",
          packageBasePrice: "",
          packageCode: "",
          packagesFnoCatId: "",
          packagesIspLocationNetworkId: "",
          speedProfileId: "",
          startDate: "",
          xeroProductId: ""
        }
      ],
      fnoHeaders: [
        {
          text: "Package Category",
          align: "center",
          value: "packageFnoCat.packageCatType"
        },
        {
          text: "FNO Package Code",
          align: "center",
          value: "packageCode"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Price",
          align: "center",
          value: "packageBasePrice"
        }
      ],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "ISP Name",
          align: "center",
          value: "name"
        },
        {
          text: "Packages Shared",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  methods: {
    editItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.item = Object.assign({}, item);
        let packages = [];
        for (let i = 0; i < this.item.packagesFno.length; i++) {
          packages.push(this.item.packagesFno[i].fnoPackage);
        }
        this.initialSelectedPackages = packages;
        this.selected = packages;
        this.editIspModal = true;
      }
    },
    addItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.addIspModal = true;
      }
    },
    deleteItem() {
      if (this.authDelete(this.$store.state.currentRoute)) {
        this.removeIspModal = true;
      }
    },
    async saveEditedIsp() {
      let selected = this.selected.map(x=>x.id)
      let existing = this.initialSelectedPackages.filter(x=>x.customerOrganisationId == this.item.id && x.locationNetworkId == this.$route.params.locationNetworkId)
      let newPackages = selected.filter(x=>!existing.map(y=>y.id).includes(x))
      let post = newPackages.map((x)=>({
        customerOrganisationId: this.item.id,
            locationNetworkId: this.$route.params.locationNetworkId,
            packagesFnoId: x,
            isActive: true,
            isDeleted: false
      }))
      let removedPackages = existing.filter(x=>!selected.includes(x.id))
      for(let i=0;i<removedPackages.length;i++){
        await Api().put("/supplier/ispLocationNetwork/" + removedPackages[i].id, {
          isActive: false,
          isDeleted: true
        });
      }
      // await this.selected.map(async x => {
      //   if (!this.initialSelectedPackages.find(a => a.id === x.id)) {
      //     post.push({
      //       customerOrganisationId: this.item.id,
      //       locationNetworkId: this.$route.params.locationNetworkId,
      //       packagesFnoId: x.id,
      //       isActive: true,
      //       isDeleted: false
      //     });
      //   }else if(this.initialSelectedPackages.find(a => a.id === x.id && 
      //   a.customerOrganisationId === x.customerOrganisationId && a.locationNetworkId === x.locationNetworkId && a.packagesFnoId === x.packagesFnoId)){
      //    await Api().put("/supplier/ispLocationNetwork/" + a.id, {
      //         isActive: true,
      //         isDeleted: false
      //       });
      //   }
      // });
      if (post.length > 0) {
        await Api()
          .post("/ispLocationNetwork", {
            batch: post
          })
          .then(response => {
            if (response.status === 200) {
              post = [];
            }
          });
      }

      for (let a = 0; a < this.initialSelectedPackages.length; a++) {
        if (!this.selected.includes(this.initialSelectedPackages[a])) {
          let id = this.initialSelectedPackages[a].id;
          let array = await this.item.ref.filter(function(el) {
            return el.packagesFnoId === id;
          });
          // console.log(array)
          for (let b = 0; b < array.length; b++) {
            await Api().put("/supplier/ispLocationNetwork/" + array[b].id, {
              isActive: false,
              isDeleted: true
            });
          }
        }
      }
      this.$emit("ispPackageAdded");
      this.editIspModal = false;
      this.item = {};
    },
    removeIspFromNetwork(item) {
      // if (this.authDelete(this.$store.state.currentRoute)) {
        // if (
        //   confirm("Are you sure you want to remove this ISP from this network?")
        // ) {
        //   let updateIdArray = [];
          // for (let i = 0; i < item.ref.length; i++) {
            confirm("Are you sure you want to remove this ISP from this network?") &&
            Api()
              .put("/supplier/remove/ispLocationNetwork/" + item.id+'/'+item.locationNetworkId, {
                isActive: false,
                isDeleted: true
              })
              .then(this.$emit("ispPackageAdded"));
          // }
        // }
      // }
    },
    addIspToNetwork() {
      let post = [];
      for (let i = 0; i < this.selected.length; i++) {
        post.push({
          customerOrganisationId: this.selectedIsp,
          locationNetworkId: this.$route.params.locationNetworkId,
          packagesFnoId: this.selected[i].id,
          isActive: true,
          isDeleted: false
        });
      }
      Api()
        .post("/ispLocationNetwork", {
          batch: post
        })
        .then(response => {
          this.$emit("ispPackageAdded");
        });
    },
    sharedPackages(item){
      let uniquePackages = [...new Set(this.fnopackages.map(item => item.id))];
      let ispPackages = [...new Set(item.packagesFno.map(item => item.fnoPackage.id))]
      return ispPackages.length+'/'+uniquePackages.length
    }
  }
};
</script>
<style>
.v-chip.Active {
  background: #1ebb2c;
}
.v-chip.Inactive {
  background: #f0121e;
}
</style>

